module.exports = __webpack_public_path__ + "a98d1e35258db0f748a41d4003255f8a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/gear-s.png
// module id = 2534
// module chunks = 0